import { takeLatest, put } from 'redux-saga/effects'
import { AuthenticationDetails, CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js'
import { SIGN_IN, SignInActionType } from '../redux/authReducer'
import { FETCH_TUTOR } from '../redux/tutorReducer'
import userPool from '../helpers/userPool'
import { SIGN_IN_SUCCESS, SIGN_IN_FAIL } from '../redux/authReducer'

export const authenticate = async (Email: string, Password: string): Promise<CognitoUserSession> => {
  return await new Promise((resolve, reject) => {
    const user = new CognitoUser({
      Username: Email,
      Pool: userPool
    })

    const authDetails = new AuthenticationDetails({
      Username: Email,
      Password
    })

    user.authenticateUser(authDetails, {
      onSuccess: (result) => {
        resolve(result)
      },
      onFailure: (err) => {
        reject(err)
      }
    })
  })
}

function* SignInFlow(action: SignInActionType): Generator<any, void, any> {
  try {
    yield authenticate(action.payload.email, action.payload.password)
    yield put(FETCH_TUTOR())
    yield put(SIGN_IN_SUCCESS())
  } catch (error) {
    console.log(error)
    yield put(SIGN_IN_FAIL())
  }
}

export default function* SignIn(): Generator<any, void, any> {
  yield takeLatest([SIGN_IN], SignInFlow)
}
